import { SUBMIT_FORM } from "@/store/actions.type";
import { SET_SUBMIT_FORM, SET_FORM_ERRORS } from "@/store/mutations.type";
import { SubmitFormService } from "@/core/services/api";

const actions = {
    [SUBMIT_FORM]({ commit }, params) {
        return SubmitFormService.post(params)
            .then(({ data }) => {
                commit(SET_SUBMIT_FORM, data);
            })
            .catch(error => { 

                if ('response' in error && 'errors' in error.response.data) {
                    commit(SET_FORM_ERRORS,  error.response.data.errors);
                }

                commit(SET_SUBMIT_FORM, []);
              
                return error;
            });
    }
}

export default actions;